import { Text } from '@sparemin/blockhead';
import React from 'react';
import GradientBorder from 'components/GradientBorder';
import bem from 'utils/bem';

export const block = bem('gradient-badge');

export interface GradientBadgeProps {
  contents: string;
}

const GradientBadge: React.FC<GradientBadgeProps> = ({ contents }) => {
  return (
    <GradientBorder className={block()}>
      <Text variant="p">{contents}</Text>
    </GradientBorder>
  );
};

export default GradientBadge;
